import { render, staticRenderFns } from "./BoxEntriesBody.vue?vue&type=template&id=24745a1a&"
import script from "./BoxEntriesBody.vue?vue&type=script&lang=ts&"
export * from "./BoxEntriesBody.vue?vue&type=script&lang=ts&"
import style0 from "./BoxEntriesBody.vue?vue&type=style&index=0&id=24745a1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports